export enum SurveyFormQuestionType {
    bool = "bool",
    choice = "choice",
    text = "text"
}

export interface SurveyFormModel {
    id: string;
    name: string;
    created: Date;
    questions: SurveyFormQuestionModel[];
    comment?: string;
    greetingText?: string;
    finishText?: string;
}

export const SurveyFormQuestionTypeNames:
    { type: SurveyFormQuestionType, name: string }[] =
    [
        {type: SurveyFormQuestionType.bool, name: "Логический вопрос (ДА/НЕТ)"},
        {type: SurveyFormQuestionType.choice, name: "Выбор из списка"},
        {type: SurveyFormQuestionType.text, name: "Текст"}
    ];

export interface BaseSurveyFormQuestionModel {
    id: string;
    type: SurveyFormQuestionType;
    questionDisplayText: string;
    comment?: string;
    answers?: SurveyFormAnswerModel[];
}

export interface SurveyFormAnswerModel {
    choice: SurveyFormChoice;
    questions: SurveyFormQuestionModel[];
}

export interface BoolSurveyFormQuestionModel extends BaseSurveyFormQuestionModel {
    type: SurveyFormQuestionType.bool;
    valueTrue?: string;
    valueFalse?: string;
    buttonTrueDisplayText?: string;
    buttonFalseDisplayText?: string;
}

export interface SurveyFormChoice {
    value?: string;
    displayText: string;
    displayOrder?: number;
}

export interface ChoiceSurveyFormQuestionModel extends BaseSurveyFormQuestionModel {
    type: SurveyFormQuestionType.choice;
    choices: SurveyFormChoice[];
    multiselect: boolean;
    multiselectMaxAnswerCount?: number;
}

export interface TextSurveyFormQuestionModel extends BaseSurveyFormQuestionModel {
    type: SurveyFormQuestionType.text;
    maxLength?: number;
}

export type SurveyFormQuestionModel = (BoolSurveyFormQuestionModel | ChoiceSurveyFormQuestionModel | TextSurveyFormQuestionModel);

export enum SurveyFormEditorNodeType {
    question = "question",
    answer = "answer"
}

export interface SurveyFormNode {
    type: SurveyFormEditorNodeType;
    question?: SurveyFormQuestionModel;
    answer?: SurveyFormAnswerModel;
}

